import React from 'react';
import { motion } from 'framer-motion';
import { ScaleIcon, TrophyIcon, AlertTriangleIcon, RadioIcon } from 'lucide-react';
export function Rules() {
  return <section id="pravidla" className="relative w-full bg-mist py-24 px-6 scroll-mt-20 overflow-hidden" data-id="element-229" data-mp="m3tclrql0dm8">
      {/* Background Image */}
      <div className="absolute inset-0 z-0 pointer-events-none" style={{
      backgroundImage: 'url("https://cdn.magicpatterns.com/uploads/mukNHx9uaN2UkH4Wg5ELUP/DSC01389.jpg")',
      backgroundSize: 'cover',
      backgroundPosition: 'center',
      opacity: 0.7
    }} data-id="element-230" data-mp="ccyrwrszhm2w" />

      <div className="relative z-10 max-w-6xl mx-auto" data-id="element-231" data-mp="q5odww8iir00">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.8
      }} className="mb-16" data-id="element-232" data-mp="v1nav87wphc1">
          <h2 className="text-[48px] font-[200] mb-4 text-[#FFFFFF]" data-id="element-233" data-mp="1hw65whcwxnmx">
            Soutěžní pravidla a procedury
          </h2>
          <p className="max-w-2xl text-lg text-[#FFFFFF]" data-id="element-234" data-mp="1qui4p6nxnrqg">
            Spinnaker a gennaker jsou povoleny, pokud rozhodčí nevyhlásí jinak.
            Vše se řídí fair-play a námořním právem.
          </p>
        </motion.div>

        <div className="grid md:grid-cols-2 gap-8" data-id="element-235" data-mp="20s4pg9rwydic">
          {/* Bodování */}
          <motion.div initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.8,
          delay: 0.1
        }} className="bg-white/10 backdrop-blur-sm p-8 rounded-xl shadow-sm border border-white/10" data-id="element-236" data-mp="1vu36rpyegg7e">
            <div className="flex items-center gap-4 mb-6" data-id="element-237" data-mp="2eihtw25lja2x">
              <div className="bg-white/20 p-3 rounded-lg text-white" data-id="element-238" data-mp="1c87suxdfx1r6">
                <ScaleIcon className="w-6 h-6" data-id="element-239" data-mp="1g8045hu7xm08" />
              </div>
              <h3 className="text-xl font-semibold text-white" data-id="element-240" data-mp="1g65i2077nnuk">
                Bodování a hodnocení
              </h3>
            </div>
            <ul className="space-y-3 text-white/90" data-id="element-241" data-mp="1pyl0szqc0ggi">
              <li data-id="element-242" data-mp="1q0eaknw8rgsq">
                • Boduje se nízkobodovým systémem (1. místo = 1 bod, 2. místo =
                2 body...).
              </li>
              <li data-id="element-243" data-mp="1zvpqh9jdyu22">• Za každé odjeté 4 rozjížďky se jedna nejhorší škrtá.</li>
              <li data-id="element-244" data-mp="23yc9qm1zr6nn">• Rozhodčí může vyhlásit rozjížďku s vícebodovým ziskem.</li>
              <li data-id="element-245" data-mp="23w9m28ob9pm3">
                • Limity dojezdů mohou být upraveny během plavby přes VHF a
                WhatsApp.
              </li>
            </ul>
          </motion.div>

          {/* Modrá stuha */}
          <motion.div initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.8,
          delay: 0.2
        }} className="bg-white/10 backdrop-blur-sm p-8 rounded-xl shadow-sm border-l-4 border-blue-medium border-t border-r border-b border-white/10" data-id="element-246" data-mp="ej64zz9uzumz">
            <div className="flex items-center gap-4 mb-6" data-id="element-247" data-mp="pz11x71ifblw">
              <div className="bg-white/20 p-3 rounded-lg text-white" data-id="element-248" data-mp="pweur8ij6y47">
                <TrophyIcon className="w-6 h-6" data-id="element-249" data-mp="l0pqwszhav23" />
              </div>
              <h3 className="text-xl font-semibold text-white" data-id="element-250" data-mp="fzsaaku4a92p">Modrá stuha</h3>
            </div>
            <p className="text-white/90 mb-4" data-id="element-251" data-mp="bz9hanghmwyx">
              Vyhlašuje se i vložená soutěž pro posádku s nejkratším celkovým
              časem ze všech rozjížděk (včetně škrtaných v hlavní soutěži).
            </p>
            <p className="text-sm text-white/70 italic" data-id="element-252" data-mp="2wopbztitv5tu">
              Podmínkou účasti je odjetí všech vyhlášených rozjížděk. Posádka si
              může "vypůjčit" zkušeného jachtaře z rozhodcovské lodě pro
              zdokonalení – tato rozjížďka se však lodi škrtá.
            </p>
          </motion.div>

          {/* Startovací procedura */}
          <motion.div initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.8,
          delay: 0.3
        }} className="bg-white/10 backdrop-blur-sm p-8 rounded-xl shadow-sm border border-white/10" data-id="element-253" data-mp="eg8ica30izhv">
            <div className="flex items-center gap-4 mb-6" data-id="element-254" data-mp="1262tmn7oog00">
              <div className="bg-white/20 p-3 rounded-lg text-white" data-id="element-255" data-mp="3ivrtnehdlol4">
                <RadioIcon className="w-6 h-6" data-id="element-256" data-mp="3iynsr64ymjb5" />
              </div>
              <h3 className="text-xl font-semibold text-white" data-id="element-257" data-mp="3mzg1ly9x6m6w">
                Startovací procedura
              </h3>
            </div>
            <p className="text-white/90 mb-4" data-id="element-258" data-mp="3afas82k6nlhp">
              Procedura bude 5, 4, 1 (min.), start. Zvukové znamení probíhá
              prostřednictvím vysílačky:
            </p>
            <ul className="space-y-2 text-sm text-white/80 bg-black/20 p-4 rounded-lg font-mono" data-id="element-259" data-mp="3pagwol3mrc8x">
              <li data-id="element-260" data-mp="3kbdq2w804xyu">10 min - "Alpha ... 5,4,3,2,1, teď"</li>
              <li data-id="element-261" data-mp="2woxjvz3dq4ru">5 min - "Charlie ... 5,4,3,2,1, teď" (zahájení)</li>
              <li data-id="element-262" data-mp="2rp1ga0ylgfct">4 min - "Kilo ... 5,4,3,2,1, teď" (vypnutí motoru)</li>
              <li data-id="element-263" data-mp="2rmoq50iomyoo">1 min - "Lima ... 5,4,3,2,1, teď" (synchronizace)</li>
              <li data-id="element-264" data-mp="36f8n1jf8o9xo">START - "November ... 5,4,3,2,1, teď"</li>
            </ul>
          </motion.div>

          {/* Bezpečnost a tresty */}
          <motion.div initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.8,
          delay: 0.4
        }} className="bg-white/10 backdrop-blur-sm p-8 rounded-xl shadow-sm border border-white/10" data-id="element-265" data-mp="31l4i15pjabz8">
            <div className="flex items-center gap-4 mb-6" data-id="element-266" data-mp="37fiyq1vnmc59">
              <div className="bg-white/20 p-3 rounded-lg text-white" data-id="element-267" data-mp="3ce3o169dbbex">
                <AlertTriangleIcon className="w-6 h-6" data-id="element-268" data-mp="2fnkybxbe5sjd" />
              </div>
              <h3 className="text-xl font-semibold text-white" data-id="element-269" data-mp="2fpnxb6uiuw08">
                Bezpečnost a tresty
              </h3>
            </div>
            <ul className="space-y-3 text-white/90" data-id="element-270" data-mp="2ooj2cflty01y">
              <li data-id="element-271" data-mp="2omy7spzimh43">
                • <strong data-id="element-272" data-mp="2oqm1pq8vh5jc">Motor:</strong> Lze nastartovat z bezpečnostních
                důvodů bez penalizace (bez zařazené rychlosti, nutno oznámit
                přes VHF).
              </li>
              <li data-id="element-273" data-mp="40ekrzytsbat">
                • <strong data-id="element-274" data-mp="8wv7qquagjmb">Vyhýbání:</strong> Striktně dle COLREGu. Plachetnice
                dává přednost běžným motorovým lodím, rybářům a veřejné dopravě.
              </li>
              <li data-id="element-275" data-mp="1th8te2y4hv9m">
                • <strong data-id="element-276" data-mp="1ogcopn5y6535">Penalizace:</strong> Při přejetí startovní linie nebo
                nedání přednosti je trest 360° otočka do cíle rozjížďky.
                Poškozená loď hlásí "PROTEST" vysílačkou i do WhatsApp skupiny.
              </li>
            </ul>
          </motion.div>
        </div>
      </div>
    </section>;
}